// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css - Angled Sidebar with Animation */

body {
  font-family: "Lato", sans-serif;
  background: url("https://images.unsplash.com/photo-1444927714506-8492d94b4e3d?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&s=067f0b097deff88a789e125210406ffe")
    center center no-repeat; 
  background-size: cover; 
  background-attachment: fixed; 
  height: 100%;
  margin: 0; 
}


/* Sidebar Base */
.navigation-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 500px;
  height: 100%;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
}

/* Angled Background Effect */
.navigation-menu::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 400%;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%) rotate(40deg);
  z-index: 0;
  background: rgba(48, 94, 122); /* 70% opacity */
}

/* Open State */
.navigation-menu--open {
  transform: translateX(0);
}

/* Toggle Button */
.navigation-menu__toggle {
  position: absolute;
  top: 20px;
  right: -50px;
  width: 40px;
  height: 40px;
  background: #741c25;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navigation-menu__bars {
  position: relative;
  width: 25px;
  height: 2px;
  background: white;
  transition: background 0.3s ease-in-out;
}

.navigation-menu__bars::before,
.navigation-menu__bars::after {
  content: "";
  position: absolute;
  width: 25px;
  height: 2px;
  background: white;
  transition: transform 0.3s ease-in-out;
}

.navigation-menu__bars::before {
  top: -8px;
}

.navigation-menu__bars::after {
  top: 8px;
}

/* X (close) Animation */
.navigation-menu--open .navigation-menu__bars {
  background: transparent;
}

.navigation-menu--open .navigation-menu__bars::before {
  transform: rotate(45deg);
  top: 0;
}

.navigation-menu--open .navigation-menu__bars::after {
  transform: rotate(-45deg);
  top: 0;
}

/* Menu List */
.menu-list {
  position: relative;
  padding: 80px 30px;
  margin: 0;
  list-style: none;
  z-index: 10; 
}

.menu-list__item {
  opacity: 0;
  margin: 20px 0;
  font-size: 17px;
  color: white;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
}

.navigation-menu--open .menu-list__item {
  opacity: 1;
}

.menu-list__item a {
  color: white;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
}

.menu-list__item a:hover {
  color: #f87225;
}

/* Mobile Responsive */
@media only screen and (max-width: 700px) {
  .navigation-menu {
    width: 240px; 
  }
}

@media only screen and (max-width: 480px) {
  .navigation-menu {
    background-color: #adb0bd;
    width: 80%;  
  }

  .navigation-menu__toggle {
    right: -40px;
  }
}

/* Submenu styles */
.submenu {
  list-style: none; 
  padding-left: 20px; 
  margin: 0; 
  
}

.submenu__item {
  font-size: 14px; 
  padding: 5px 0; 
  
}

.submenu__item a {
  text-decoration: none; 
  color: white; 
  transition: color 0.3s ease-in-out;
}

.submenu__item a:hover {
  color: #f87225; 
}
`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAGhD;EACE,+BAA+B;EAC/B;2BACyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,SAAS;AACX;;;AAGA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,MAAM;EACN,8CAA8C;EAC9C,UAAU;EACV,6BAA6B,EAAE,gBAAgB;AACjD;;AAEA,eAAe;AACf;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,MAAM;AACR;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;;AAEX;;AAEA;EACE,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Sidebar.css - Angled Sidebar with Animation */\n@import url(\"https://fonts.googleapis.com/css?family=Lato:400\");\n\nbody {\n  font-family: \"Lato\", sans-serif;\n  background: url(\"https://images.unsplash.com/photo-1444927714506-8492d94b4e3d?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&s=067f0b097deff88a789e125210406ffe\")\n    center center no-repeat; \n  background-size: cover; \n  background-attachment: fixed; \n  height: 100%;\n  margin: 0; \n}\n\n\n/* Sidebar Base */\n.navigation-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 500px;\n  height: 100%;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n/* Angled Background Effect */\n.navigation-menu::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 400%;\n  left: 50%;\n  top: 0;\n  transform: translate(-50%, -50%) rotate(40deg);\n  z-index: 0;\n  background: rgba(48, 94, 122); /* 70% opacity */\n}\n\n/* Open State */\n.navigation-menu--open {\n  transform: translateX(0);\n}\n\n/* Toggle Button */\n.navigation-menu__toggle {\n  position: absolute;\n  top: 20px;\n  right: -50px;\n  width: 40px;\n  height: 40px;\n  background: #741c25;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.navigation-menu__bars {\n  position: relative;\n  width: 25px;\n  height: 2px;\n  background: white;\n  transition: background 0.3s ease-in-out;\n}\n\n.navigation-menu__bars::before,\n.navigation-menu__bars::after {\n  content: \"\";\n  position: absolute;\n  width: 25px;\n  height: 2px;\n  background: white;\n  transition: transform 0.3s ease-in-out;\n}\n\n.navigation-menu__bars::before {\n  top: -8px;\n}\n\n.navigation-menu__bars::after {\n  top: 8px;\n}\n\n/* X (close) Animation */\n.navigation-menu--open .navigation-menu__bars {\n  background: transparent;\n}\n\n.navigation-menu--open .navigation-menu__bars::before {\n  transform: rotate(45deg);\n  top: 0;\n}\n\n.navigation-menu--open .navigation-menu__bars::after {\n  transform: rotate(-45deg);\n  top: 0;\n}\n\n/* Menu List */\n.menu-list {\n  position: relative;\n  padding: 80px 30px;\n  margin: 0;\n  list-style: none;\n  z-index: 10; \n}\n\n.menu-list__item {\n  opacity: 0;\n  margin: 20px 0;\n  font-size: 17px;\n  color: white;\n  cursor: pointer;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.navigation-menu--open .menu-list__item {\n  opacity: 1;\n}\n\n.menu-list__item a {\n  color: white;\n  text-decoration: none;\n  transition: color 0.3s ease-in-out;\n}\n\n.menu-list__item a:hover {\n  color: #f87225;\n}\n\n/* Mobile Responsive */\n@media only screen and (max-width: 700px) {\n  .navigation-menu {\n    width: 240px; \n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .navigation-menu {\n    background-color: #adb0bd;\n    width: 80%;  \n  }\n\n  .navigation-menu__toggle {\n    right: -40px;\n  }\n}\n\n/* Submenu styles */\n.submenu {\n  list-style: none; \n  padding-left: 20px; \n  margin: 0; \n  \n}\n\n.submenu__item {\n  font-size: 14px; \n  padding: 5px 0; \n  \n}\n\n.submenu__item a {\n  text-decoration: none; \n  color: white; \n  transition: color 0.3s ease-in-out;\n}\n\n.submenu__item a:hover {\n  color: #f87225; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
